import { AxiosResponse } from 'axios'
import { Recommendation, RecommendationCreateOneRequest, RecommendationResponse } from '../../../../types'
import { HttpClientConfig } from '../../../useHttpClientConfig'
import { applySearchParams } from '../../appointments/utils'
import { apiVersion, service } from '../service'

const pathname = `/api/${apiVersion}/recommendation`

const makeCreateRecommendation =
  (baseUrl: string, config: HttpClientConfig) =>
  async (request: RecommendationCreateOneRequest): Promise<Recommendation> => {
    const url = new URL(pathname, baseUrl)

    applySearchParams(url, request as unknown as Record<string, string>)

    const { data } = await service(baseUrl).post<RecommendationCreateOneRequest, AxiosResponse<RecommendationResponse>>(
      pathname,
      request,
      config
    )

    return data.data
  }

export { makeCreateRecommendation }
